import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import Loader from '../Loader';
import StudentPage from '../views/StudentPage';
const GLOBAL = require('../Globals');


class Promotion extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			cls : '',
			section : '',
			acyear1 : '',
			cls1 : '',
			section1 : '',
			_message : '',
			alertClass :'',
			posts : [],
			data : [],
			postFilter : [],
			seclist1 : [],
			seclist : [],
			accyear : [],
			accyear1 : [],
			_redirect : false,
			att : [],
			posts1 : [],
			sections : [],
			sections1 : [],
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onAcYearChange = this.onAcYearChange.bind(this);
		this.onCurYearChange = this.onCurYearChange.bind(this);
		this.onSectionChange = this.onSectionChange.bind(this);
	}
	
	/** redirect to Edit Promotion **/
	onBack(e){
		
		this.setState({_redirect :true});
	}
	
	 printDocument() {
		const input = document.getElementById('printableTable');
		html2canvas(input)
		  .then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF();
			pdf.addImage(imgData, 'JPEG', 0, 0);
			pdf.save("download.pdf");
		  })
		;
		/* window.frames["print_frame"].document.body.innerHTML = document.getElementById("printableTable").innerHTML;
         window.frames["print_frame"].window.focus();
         window.frames["print_frame"].window.print(); */
		
	 }
	
	
	onStatusChange(id,e){
		
		var index = this.state.att.findIndex(function(obj){
		// var obj=JSON.parse(objstr);
		return (obj.regno == id); });
		
		if(index === -1){ 
			this.state.att.push({"regno":id, "status":e.target.value, "remarks":0});
		}
		else{
			
			this.state.att[index].status = e.target.value;
		}
	}
	
	onRemarkChange(id,e){
		
		if(e.target.value!=''){
			var index = this.state.att.findIndex(function(obj){
			return (obj.regno == id); });
			
			if(index != -1){ 
				
				this.state.att[index].remarks = e.target.value;
				
			}
		}
	}
	
	onAcYearChange(e){
		
		this.state.acyear = e.target.value;
		this.getdata();
		this.getclass();
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		// this.getdata();
		// this.getclass();
		//this.getclass1();
	}
	
	onCurYearChange(e){
		this.setState({[e.target.name]:e.target.value});
		this.getclass1();
		this.getsection1();
	}
	
	onSectionChange(e){
		
		this.state.section = e.target.value;
		this.filterdata();
	}

	onClassChange(e){
		
		this.state.cls = e.target.value;
		var ar = $("#year").val();
		if(ar!=''){
			$("#showLoader").show();
			GetData('section/getsecbyclass/'+ar+'/'+e.target.value).then((result) => {
				 $("#showLoader").hide();
				let res = result;
				if(res){
					this.setState({sections : res});
				}
			});
		}
		this.filterdata();
	}
	
	onClass1Change(e){
		this.state.cls1 = e.target.value;
		var ar = $("#year1").val();
		if(ar!=''){
			$("#showLoader").show();
			GetData('section/getsecbyclass/'+ar+'/'+e.target.value).then((result) => {
				 $("#showLoader").hide();
				let res = result;
				if(res){
					this.setState({sections1 : res});
				}
			});
		}
	}
	
	onSubmit(e){
		e.preventDefault();
		//$("#load_area").show();
		$("#showLoader").show();
		if (window.confirm("Do you want to Promote?")) { 	
			PostData('student/promotion',this.state).then((result) => {
				$("#showLoader").hide();
				$("#load_area").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					alert('Promoted Successfully');
					document.getElementById("proform").reset();
					$("#stdtable").hide();
					$("#todata").hide();
				}
				else{
			
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
		else{
			$("#showLoader").hide();
		}
	}
	
	componentWillMount() {
		 
		this.getcuracyear();
		this.getacyear();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getcuracyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	/** get Current Academic Year **/
	getcuracyear(){
		
		GetData('academic/getlastacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear1 : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		var ac = $("#year").val();
		GetData('classs/getclasbyacyear/'+ac).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass1(){
		
		var ac = $("#year1").val();
		GetData('classs/getclasbyacyear/'+ac).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts1 : responseJson
				});
			}
		});
	}
	
	/** get Student Data **/
	getdata(){
		
		this.setState({data : []});
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getstddetails/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson,
					postFilter : responseJson
				});
			}
		});
	}
	
	filterdata(){
		
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.data.length; i++){
			
			if(this.state.cls != '' && this.state.section != ''){
				
				if(this.state.data[i].class == this.state.cls && this.state.data[i].section == this.state.section){
					
					dat.push(this.state.data[i]);
				}
			}
			
		}
		this.setState({postFilter : dat});
	}
	
  render() {
	  
	  $("#load_area").hide();
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/editpromote'} />);

	}
	
	/** set status select box **/
	this.stdstatus = [
		{value : 'pass', name : 'Pass'},
		{value : 'fail', name : 'Fail'},
		{value : 'transfer', name : 'Transfer'}
	];
	
	var items = this.state.posts;
	var items1 = this.state.posts1;
	var sec = this.state.sections;
	var sec1 = this.state.sections1;
	var acyear = this.state.accyear;
	var acyear1 = this.state.accyear1;
	
	if(this.state.acyear!='' && this.state.cls!='' && this.state.section!=''){
			
		$("#stdtable").show();
		$("#todata").show();
	}
	else{
		
		$("#stdtable").hide();
		$("#todata").hide();
	}
	
	if(this.state.cls == '15'){
		
		// $(".status option").eq(2).prop('selected', true).trigger('change');
		// $(".status").val('transfer').trigger('change');
		$("#year1").prop('required', false);
		$("#clas1").prop('required', false);
		$("#secs1").prop('required', false);
	}
	else{
		
		$(".status").val('pass').trigger('change');
	}
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<form action="" method="post" role="form" id="proform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Promotion</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onBack}>Edit</Button>
						</CardHeader>
						<CardBody>
							<Row>
							 <Col md="12">
								<Row>
									<Col md="1">
										 <FormGroup>
											From :
										 </FormGroup>
									</Col>
									<Col md="4">
									  <FormGroup>
										Academic Year : &nbsp;&nbsp;
										<select name="acyear" onChange={this.onAcYearChange} required id="year">
											<option value="">Select Academic Year</option>
											{
												acyear1.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
									  </FormGroup>
									</Col>
									<Col md="2">
									  <FormGroup>
										Class : &nbsp;&nbsp;
										<select name="cls" onChange={this.onClassChange} id="clas" required> 
											<option value="">Select Class</option>
											{
												items.map(function (item) {
													return <option value={item.class}>{item.cls}</option>;
												})
											}
										</select>
									  </FormGroup>
									</Col>
									<Col md="3">
									  <FormGroup>
										Section : &nbsp;&nbsp;
										<select name="section" onChange={this.onSectionChange} id="secs" required>
											<option value="">Select Section</option>
											{
												sec.map(function (item) {
													return <option value={item.id}>{item.secs}</option>;
												})
											}			
										</select>
									  </FormGroup>
									</Col>
								</Row>
								<Row id="todata">
									<Col md="1">
										 <FormGroup>
											To :
										 </FormGroup>
									</Col>
									<Col md="4">
									  <FormGroup>
										Academic Year : &nbsp;&nbsp;
										<select name="acyear1" onChange={this.onCurYearChange} required id="year1">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id }>{item.value}</option>;
												})
											}
										</select>
									  </FormGroup>
									</Col>
									<Col md="2">
									  <FormGroup>
										Class : &nbsp;&nbsp;
										<select name="cls1" onChange={this.onClass1Change.bind(this)} id="clas1" required> 
											<option value="">Select Class</option>
											{
												items1.map(function (item) {
													return <option value={item.class}>{item.cls}</option>;
												})
											}
										</select>
									  </FormGroup>
									</Col>
									<Col md="3">
									  <FormGroup>
										Section : &nbsp;&nbsp;
										<select name="section1" onChange={this.onChange} id="secs1" required>
											<option value="">Select Section</option>
											{
												sec1.map(function (item) {
													return <option value={item.id}>{item.secs}</option>;
												})
											}		
										</select>
									  </FormGroup>
									</Col>
								</Row>
							 </Col>
							 <Col md="12">
								<Table responsive bordered  id="stdtable">
								  <thead>
									<tr>
										<th>S.No</th>
										<th>Reg no</th>
										<th>Student Name</th>
										<th>Status</th>
										<th>Remarks</th>
									</tr>
								  </thead>
								  <tbody>
									{this.state.postFilter.map((item,index) =>
										<tr key = {index}>
											<td>{index+1}</td>
											<td>{item.regno}</td>
											<td>{item.stdname}</td>
											<td>
											  <select name="stdstatus" className="status" onChange={this.onStatusChange.bind(this,item.regno)}>
												{this.stdstatus.map((e, key) => {
													return <option key={key} value={e.value}>{e.name}</option>;
												})}	
											 </select>
											</td>
											<td><input type="text" onBlur={this.onRemarkChange.bind(this,item.regno)} /></td>
										</tr>
									)}
								  </tbody>
								</Table>
							 </Col>
							</Row>
							<Row>
							<Col md="10"><span id="load_area"><Loader /></span></Col><Col md="2"><Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Promotion</Button></Col> 
							</Row>
						</CardBody>
			
					</Card>
				  </Col>
				</Row>
			</form>
			</div>
		</div>
	)
  }
}

export default Promotion;


// WEBPACK FOOTER //
// ./src/Promotion/Promotion.js